import { useEffect, useState } from 'react'
import { trainingBillingStore } from '../services/trainingBillingStore'

export function useTrainingBilling() {
  const [records, setRecords] = useState(trainingBillingStore.getAll())

  useEffect(
    () =>
      trainingBillingStore.subscribe(() =>
        setRecords(trainingBillingStore.getAll()),
      ),
    [],
  )

  return records
}
